import {IFaqItem, IFaqState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getFaqContent} from "./ActionCreators";

const initialValue: IFaqState = {
    content: [],
    loading: false
}

const faqSlice = createSlice({
    name: SliceNames.FAQ,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getFaqContent.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getFaqContent.fulfilled, (state, action: PayloadAction<IFaqItem[]>) => {
                    state.content = action.payload
                    state.loading = false
                })
            .addCase(
                getFaqContent.rejected, (state) => {
                    state.loading = false
                })
    }
})

export default faqSlice.reducer
